var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiFormatAlignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13 9l2.5-2.5l1.42 1.42L12 12.84L7.08 7.92L8.5 6.5L11 9V3h2zM3 15h18v2H3zm0 4h10v2H3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFormatAlignBottom);
export default __webpack_public_path__ + "static/media/MdiFormatAlignBottom.424ef383923a3210fbce8cd26c1f62bf.svg";
export { ForwardRef as ReactComponent };